/* PeanutJi: every card "add to cart" button adds via AJAX and opens the right-hand cart drawer. */
(function () {
  if (window.__pjAtc) return;
  window.__pjAtc = true;

  function sectionIds() {
    return [].slice.call(document.querySelectorAll('cart-items-component'))
      .map(function (c) { return c.dataset.sectionId; }).filter(Boolean);
  }

  async function add(variantId, btn) {
    var body = { id: variantId, quantity: 1 };
    var ids = sectionIds();
    if (ids.length) body.sections = ids.join(',');
    var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
    if (res.status) throw new Error(res.description || res.message || 'add failed');

    var mod = await import('@shopify/events');
    var Evt = mod.CartLinesUpdateEvent;
    var deferred = Evt.createPromise();
    document.dispatchEvent(new Evt({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise
    }));
    var ajaxCart = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    deferred.resolve({
      cart: Evt.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'product-form-component',
        sourceId: 'pj-card',
        itemCount: 1,
        productId: String(res.product_id || ''),
        sections: res.sections,
        didError: false
      }
    });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-pj-drawer-add]');
    if (q) {
      e.preventDefault();
      if (q.classList.contains('is-adding')) return;
      q.classList.add('is-adding');
      add(q.getAttribute('data-pj-drawer-add'), q)
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { q.classList.remove('is-adding'); });
      return;
    }
    var a = e.target.closest && e.target.closest('a.peanut-cart-btn, a.peanut-add-to-cart');
    if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/cart\/(\d+):\d+/);
    if (!m || /checkout/.test(a.getAttribute('href'))) return;
    e.preventDefault();
    if (a.classList.contains('is-adding')) return;
    a.classList.add('is-adding');
    add(m[1], a).catch(function () { window.location.href = a.href; })
      .then(function () { a.classList.remove('is-adding'); });
  });
})();
